import { queryOptions } from '@tanstack/react-query';
import handle401 from '../handle-401';
import HttpClient from '../../Api/HttpClient';
import { transformAPIProjectToUI } from './project-query';

export function getProjectForCrmDeal({ crmDealId }) {
  return queryOptions({
    queryKey: ['project-for-crm-deal', crmDealId],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.fetchProjectForCrmDeal({ crmDealId });

      return data.map((project) => transformAPIProjectToUI(project));
    }),
  });
}
